import axios, { AxiosResponse, AxiosError } from 'axios';
import { SelfSetting } from '../domain/SelfSetting';

const rootUrl = document.location.protocol + '//' + document.location.host;

export const selfSetting = async (): Promise<SelfSetting> => {
  const url = rootUrl + '/selfsetting.json';
  const ret = await axios
    .get(url)
    .then((items: AxiosResponse<any>) => {
      return items.data;
    })
    .catch((error: AxiosError) => {
      throw error;
    });

  return Promise.resolve(ret);
};
